import { IconComponentType } from '@creditflowresearch/uilib/Icon';
import { TOOL_CONFIG } from '@/creditflowresearch/domain/Header/Tool/config';

class ToolIconResolver {
  static resolve(toolId: string): IconComponentType {
    return TOOL_CONFIG.icons[toolId];
  }
}

export default ToolIconResolver;
